import { Person } from '@mui/icons-material'
import {
  alpha,
  Stack,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { Dayjs } from 'dayjs'
import { useTranslation } from 'react-i18next'
import { getDaysOfTheMonth } from '../../../store/utils/worklogUtils'

type VacationTableHeaderProps = {
  chosenDate: string | null
  selectedDate: Dayjs
  isFiltersOpen: boolean
  isSingleRowRender: boolean
  handleDateSelectorClick: (day: string) => void
}

const VacationTableHeader = ({
  chosenDate,
  selectedDate,
  isFiltersOpen,
  isSingleRowRender,
  handleDateSelectorClick,
}: VacationTableHeaderProps) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const isDownXsMid = useMediaQuery(theme.breakpoints.down('xsMid'))

  return (
    <TableHead sx={{ height: '50px' }}>
      <TableRow sx={{ position: 'sticky', top: 0, zIndex: 11, backgroundColor: 'background.elevation1' }}>
        <TableCell
          sx={{
            width: isDownXsMid ? '50px' : '167px',
            borderRight: 0,
            borderRightColor: 'background.elevation8',
            position: 'sticky',
            left: 0,
            zIndex: 12,
            pl: 1.5,
          }}
        >
          {isDownXsMid ? (
            <Tooltip title={t('page.projects.detailsView.employee')} arrow>
              <Person sx={{ verticalAlign: 'middle', ml: '2px' }} />
            </Tooltip>
          ) : (
            <Typography component="h2" variant="h6">
              {t('page.projects.detailsView.employee')}
            </Typography>
          )}
        </TableCell>

        {getDaysOfTheMonth(selectedDate).map(day => (
          <TableCell
            key={day.id}
            onClick={() => {
              if (!isSingleRowRender) {
                handleDateSelectorClick(day.date.format('YYYY-MM-DD'))
              }
            }}
            onKeyDown={e => {
              if (!isSingleRowRender && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault()
                handleDateSelectorClick(day.date.format('YYYY-MM-DD'))
              }
            }}
            align="left"
            sx={{
              cursor: isSingleRowRender ? 'default' : 'pointer',
              backgroundColor:
                day.date.format('YYYY-MM-DD') === chosenDate ? alpha(theme.palette.primary.light, 0.5) : '',
              padding: !isFiltersOpen ? '0 6.5px' : '0 8px',
              borderRadius: day.date.format('YYYY-MM-DD') === chosenDate ? '4px' : '',
              position: 'sticky',
              top: 0,
              zIndex: 11,
              '&:focus': {
                outlineOffset: '-3px',
              },
              pointerEvents: isSingleRowRender ? 'none' : 'auto',
            }}
            tabIndex={isSingleRowRender ? -1 : 0}
          >
            <Stack spacing={0}>
              <Typography sx={{ fontSize: '11px', textAlign: 'center' }}>
                <span style={{ color: theme.palette.mode === 'dark' ? '#ededed' : '#000000' }}>
                  {day.date.format('DD')}
                </span>
              </Typography>
              {isFiltersOpen && (
                <Typography sx={{ fontSize: '11px', textAlign: 'center' }}>
                  <span style={{ color: '#999999' }}>{day.date.format('dd')}</span>
                </Typography>
              )}
            </Stack>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export default VacationTableHeader
